import React from "react";
import AppLogo from "../../../components/common/appLogo";

interface PublicHeaderInterface {
  isLogin?: boolean;
}

const PublicHeader: React.FC<PublicHeaderInterface> = (props) => {
  return (
    <div className="public-header">
      <AppLogo />
    </div>
  );
};

export default PublicHeader;
